export enum SearchStatus {
  Idle,
  Loading,
  Success,
  Error,
}

export type ResponseError = {
  code: string;
  message: string;
  requestId: string;
};

export type Response<T> = {
  success: boolean;
  data: T;
  error?: ResponseError;
};

export type SearchMetadata = {
  type: string;
}[];

export type SearchResultObject = {
  objectType: string;
  totalCount: number;
  objects: any[];
};

export type SearchState = {
  status: SearchStatus;
  data: SearchResultObject[];
  error?: ResponseError;
};
